import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsEquipmentInstance, PmsEquipmentInstance } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsEquipmentInstance>
    useData={usePmsEquipmentInstance}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
